import React, { useEffect, useRef } from 'react';

function StripePricingTable() {
    const stripeRef = useRef(null);

    useEffect(() => {
        // Only add the script if it does not exist yet
        if (!document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
          const script = document.createElement('script');
          script.src = "https://js.stripe.com/v3/pricing-table.js";
          script.async = true;
      
          script.onload = () => {
            // When script is loaded, create the stripe-pricing-table element
            // only if it does not exist yet
            if (!stripeRef.current.querySelector('stripe-pricing-table')) {
              const stripeElement = document.createElement('stripe-pricing-table');
      
              // Set the pricing-table-id and publishable-key attributes
              stripeElement.setAttribute('pricing-table-id', 'prctbl_1NHv0pLcU5LcUWNlx8vcSFwk');
              stripeElement.setAttribute('publishable-key', 'pk_live_51LrlqkLcU5LcUWNlSOtwn3rSRMvH87bGpzfo0bJbviZ2CfNyEoTQs8VEH5lOo7svlTAEjcuGQrYBiRu82qWc95Wa008aVte7VM');
      
              // Append the stripe-pricing-table element to the div
              stripeRef.current.appendChild(stripeElement);
            }
          };
      
          // Append the script to the document body
          document.body.appendChild(script);
      
          // Clean up on unmount
          return () => {
            document.body.removeChild(script);
          };
        }
      }, []);
      

    return (
        <div ref={stripeRef}></div>
    );
}

export default StripePricingTable;
